import { SectionHeader } from "@/components/common/section-components/SectionHeader";
import { AppRoutes } from "@/constants/routes";
import { useRoles } from "@/hooks/useRoles";
import { zodResolver } from "@hookform/resolvers/zod";
import { Flex } from "@chakra-ui/react";
import { useMemo, useState } from "react";
import { useForm, useWatch } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ServiceMasterForm } from "../components/ServiceMasterForm";
import { hasEmptyServiceMasterFormValues } from "../utils/service-master-form";
import { createServiceHandler } from "./schema/handler-functions";
import {
  ServiceMasterCreationForm,
  serviceMasterCreationSchema,
} from "./schema/service-master-creation.schema";

export const ServiceMasterCreationPage = () => {
  const navigate = useNavigate();
  const { fetchPermissions } = useRoles();

  const [loadingCreate, setLoadingCreate] = useState(false);

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<ServiceMasterCreationForm>({
    resolver: zodResolver(serviceMasterCreationSchema),
    defaultValues: {
      titulo: "",
      valorUnitario: "",
      categoria: [],
      unidadCotizacion: [],
      descripcion: "",
      cotizacionesDosis: [
        { modalidad: [], dosisDesde: "", dosisHasta: "", valorUnitario: "" },
      ],
    },
  });

  const watchedValues = useWatch({ control });

  const hasNoFilledValues = useMemo(() => {
    return hasEmptyServiceMasterFormValues(watchedValues);
  }, [watchedValues]);

  const handleCancel = () => {
    navigate(AppRoutes.SERVICES);
  };

  const onSubmit = async (values: ServiceMasterCreationForm) => {
    await createServiceHandler({
      values,
      setLoadingCreate,
      navigate,
      fetchPermissions,
    });
  };

  return (
    <Flex
      as="form"
      onSubmit={handleSubmit(onSubmit)}
      flexDir="column"
      paddingY="20px"
      gap="12px"
    >
      <SectionHeader
        title="Agregar servicio"
        addButtonLabel="Agregar"
        cancelButtonLabel="Cancelar"
        handleAdd={handleSubmit(onSubmit)}
        handleCancel={handleCancel}
        addButtonType="button"
        disableAdd={hasNoFilledValues || loadingCreate}
        loading={loadingCreate}
      />

      <ServiceMasterForm
        control={control}
        errors={errors}
        register={register}
        loading={loadingCreate}
      />
    </Flex>
  );
};
